import cx from 'classnames'
import { GrFormCheckmark } from 'react-icons/gr'
import { Fragment } from 'react'
import './ProgressIndicator.css'
import { motion } from 'motion/react'

export interface ProgressIndicatorProps {
  currentStep: number
  totalSteps: number
  className?: string
}

function ProgressIndicatorStep({
  step,
  currentStep,
  totalSteps
}: {
  step: number
  currentStep: number
  totalSteps: number
}) {
  const isPast = step < currentStep
  const isActive = step === currentStep
  const isFuture = step > currentStep
  return (
    <Fragment key={step}>
      <div className="flex items-center">
        <motion.div
          className={cx('size-6 flex items-center justify-center text-sm font-medium', {
            'bg-green-500 text-gray-700': isFuture,
            'bg-gray-700 text-green-500': isActive || isPast
          })}
          animate={{
            scale: isActive ? 1.1 : 1
          }}
          transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20
          }}
        >
          {isPast ? <GrFormCheckmark className="size-5" /> : step + 1}
        </motion.div>
      </div>
      {step < totalSteps - 1 && (
        <div className="bg-gray-400 w-full h-px mx-4 relative">
          <motion.div
            className={'bg-green-500 w-full h-px absolute top-0 left-0'}
            initial={{ scaleX: 0 }}
            animate={{ scaleX: isPast ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            style={{ originX: 0 }}
          />
        </div>
      )}
    </Fragment>
  )
}

export function ProgressIndicator({ currentStep, totalSteps, className }: ProgressIndicatorProps) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="flex items-center justify-between">
        {Array.from({ length: totalSteps }, (_, step) => (
          <ProgressIndicatorStep
            key={step}
            step={step}
            currentStep={currentStep}
            totalSteps={totalSteps}
          />
        ))}
      </div>
    </motion.div>
  )
}
